const translation = {
  supportedLocales () {
    return process.env.VUE_APP_SUPPORTED_LOCALES.split(',')
  }
}

export default translation
